import React, { FC } from 'react';

import styles from './portfolioItem.module.scss';

interface IProps {
  image: string;
  title: string;
  text?: string;
}

const PortfolioItem: FC<IProps> = ({
  image,
  title,
  text,
}) => (
  <div className={styles.container}>
    <div className={styles.wrapper}>
      <img className={styles.image} src={image} alt={title} />
    </div>
    {!!text && (
      <p className={styles.text}>
        {text}
      </p>
    )}
  </div>
);

export default PortfolioItem;
